import {http_client} from "../plugins/http_client";

const getRoles = async (queryParams = {}) => await http_client('/api/v1/roles', queryParams, 'get')
const createRole = async (body) => await http_client('/api/v1/roles', body, 'post')
const updateRole = async (idRole, body) => await http_client(`/api/v1/roles/${idRole}`, body, 'put')
const deleteRole = async (idRole) => await http_client(`/api/v1/roles/${idRole}`, {}, 'delete')
const getRolesUser = async () => await http_client('/api/v1/roles/user', {}, 'get')

//Exclusion roles

const getExclusionRoles = async (queryParams = {}) => await http_client('/api/v1/roles/excluidos', queryParams, 'get')
const getExclusionRolPerfil = async (idPerfil) => await http_client(`/api/v1/roles/excluidos/${idPerfil}`, {}, 'get')
const createExclusionRolesPerfil = async (body) => await http_client('/api/v1/roles/excluidos/', body, 'post')
const updateExclusionRolesPerfil = async (body) => await http_client('/api/v1/roles/excluidos/', body, 'put')
const deleteExclusionRolesPerfil = async (idPerfil) => await http_client(`/api/v1/roles//excluidos/${idPerfil}`, {}, 'delete')

export default {
    getRoles,
    createRole,
    updateRole,
    deleteRole,
    getRolesUser,
    getExclusionRoles,
    getExclusionRolPerfil,
    createExclusionRolesPerfil,
    updateExclusionRolesPerfil,
    deleteExclusionRolesPerfil
}